import moment from 'moment';
import { get } from 'store/http/httpAction';
import {
  TASK_LIST_PAGENATIONS,
  TASK_LIST_DATA,
  TASK_LIST_PERIOD,
  TASK_STATUS,
  SET_TEAM_MEMBERS,
  TASK_SET_ACTIVE_MEMBER,
  SET_TASK_STATUS_QUERY_TEXT,
  SET_TASK_ORDER_BY_QUERY_TEXT
} from './actionType';

export const setTaskStatus = status => ({
  type: TASK_STATUS,
  status,
});
export const setTaskStatusQueryText = text => ({
  type: SET_TASK_STATUS_QUERY_TEXT,
  text,
});
export const setTaskOrderByQueryText = text => ({
  type: SET_TASK_ORDER_BY_QUERY_TEXT,
  text,
});
const setPaginations = (perPage, currentPage, total) => ({
  type: TASK_LIST_PAGENATIONS,
  perPage,
  currentPage,
  total,
});
export const setPeriod = (start, end, overDue) => ({
  type: TASK_LIST_PERIOD,
  start,
  end,
  overDue,
});
export const setListData = data => ({
  type: TASK_LIST_DATA,
  data,
});

const setTeamMembers = data => ({
  type: SET_TEAM_MEMBERS,
  payload: { data },
});

export const setActiveMember = member => ({
  type: TASK_SET_ACTIVE_MEMBER,
  payload: { member },
});

export const fetchData = ({
  per_page,
  page,
  start_day,
  end_day,
  has_overdue,
  assign_to_user_ids,
  orderBy,
  status_code,
  priority_code
}, dispatch) => get('/admin/tasks/me/index', {
  per_page: per_page || 25,
  page: page || 1,
  start_day,
  end_day,
  current_day: has_overdue ? moment().format('YYYY-MM-DD') : '',
  has_overdue: has_overdue ? 'YES' : 'NO',
  assign_to_user_ids,
  orderBy: orderBy || '',
  status_code: status_code || '',
  priority_code: priority_code || '',
}, dispatch).then((data) => {
  dispatch(setListData(data.data || []));
  const { pagination } = data.meta;
  dispatch(setPaginations(pagination.per_page, pagination.current_page, pagination.total));
});

export const queryByPaging = (perPage, currentPage) => (dispatch, getState) => {
  const { period, teamMembers } = getState().task;
  const { start, end, overDue } = period;
  const { activeMember } = teamMembers;
  return fetchData({
    per_page: perPage,
    page: currentPage,
    start_day: start,
    end_day: end,
    has_overdue: overDue,
    assign_to_user_ids: activeMember,
  }, dispatch);
};
export const queryByPeriod = (start, end, overDue) => (dispatch, getState) => {
  const { taskDataTablePagination, teamMembers } = getState().task;
  const { perPage } = taskDataTablePagination;
  const { activeMember } = teamMembers;
  dispatch(setPeriod(start, end, overDue));
  return fetchData({
    per_page: perPage,
    page: 1,
    start_day: start,
    end_day: end,
    has_overdue: overDue,
    assign_to_user_ids: activeMember,
  }, dispatch);
};
export const queryFetch = () => (dispatch, getState) => {
  const { period, teamMembers, taskDataTablePagination } = getState().task;
  const { start, end, overDue } = period;
  const { activeMember } = teamMembers;
  const { perPage } = taskDataTablePagination;
  return fetchData({
    per_page: perPage,
    page: 1,
    start_day: start,
    end_day: end,
    has_overdue: overDue,
    assign_to_user_ids: activeMember,
  }, dispatch);
};

export const queryByCondition = ({
  perPage, currentPage, orderBy, status, priority, memberIds,
}) => (dispatch, getState) => {
  const {
    period,
    taskStatusQueryText,
    taskOrderByQueryText,
    teamMembers
  } = getState().task;
  const { start, end, overDue } = period;
  const { activeMember } = teamMembers;
  return fetchData({
    per_page: perPage,
    page: currentPage,
    start_day: start,
    end_day: end,
    has_overdue: overDue,
    assign_to_user_ids: memberIds || activeMember,
    orderBy: orderBy || taskOrderByQueryText,
    status_code: status || taskStatusQueryText,
    priority_code: priority,
  }, dispatch);
};

export const fetchTeamMembers = () => dispatch => get('/admin/users/me/members', {}, dispatch).then(data => {
  if (data && _.isArray(data.data)) {
    dispatch(setTeamMembers(data.data));
  }
});



// WEBPACK FOOTER //
// ./src/views/Task/flow/action.js